/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_State_CancelledInputs */



/**
* | output |
* | --- |
* | "Cancelled" |
*
* @param {Table_State_CancelledInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const table_state_cancelled = /** @type {((inputs?: Table_State_CancelledInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_State_CancelledInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annulée")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancelada")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cancelada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annullato")
	return /** @type {LocalizedString} */ ("Cancelled")
});